export default __webpack_public_path__ + "static/media/bill-of-lading-example.ba31b543.png";